export default "__VITE_ASSET__BS9P7FIw__"